/** @jsxImportSource @emotion/react */
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import TextArea from 'components/atoms/Textarea'

type Props = {
  show: boolean
  title: string
  description: string
  confirmLabel?: string
  onClose: () => void
  onConfirm: (note?: string) => void | Promise<void>
}

export const RefundConfirmModal: React.FC<Props> = ({
  show,
  title,
  description,
  confirmLabel = 'Mark as Refunded',
  onClose,
  onConfirm,
}) => {
  const [note, setNote] = React.useState('')
  const [submitting, setSubmitting] = React.useState(false)

  React.useEffect(() => {
    if (show) {
      setNote('')
      setSubmitting(false)
    }
  }, [show])

  const handleConfirm = async () => {
    setSubmitting(true)
    try {
      await onConfirm(note.trim() || undefined)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal centered show={show} onHide={onClose} style={{ zIndex: 100000 }}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body css={{ lineHeight: '1.3rem' }}>
        <div>{description}</div>
        <div className="mt-3">
          <TextArea
            handleChange={(e) => setNote((e.target as HTMLTextAreaElement).value)}
            name="refundNote"
            label="Note / Stripe refund reference (optional)"
            labelClassName="text-gray"
            value={note}
            rows={3}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={submitting}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
